<div class="modal fade" *ngIf="webApi.isLoggedIn()" data-bs-backdrop='static' id="subscription-update-modal" tabindex="-1"
  aria-labelledby="subscriptionModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content modal-popup subscription-popup">
      <button _ngcontent-efl-c68="" type="button" (click)="hideModal()" aria-label="Close" class="btn-close"></button>
      <div class="content-section" *ngIf="user && user.plantype=='own' && errorMessage=='' && user.plan.subscription_cancelled!=3">
        <h4 class="mb-3">Subscription Plans</h4>
        <p class="mb-0 ft-wght-300" *ngIf="!user.plan || user.plan.type!='manual'">Select between monthly or yearly payment options. 
          <!-- Get additional discount when selecting
          annual plan. -->
        </p>

        <div class="p-3 d-flex align-items-center active-plan-area mt-3" *ngIf="user && user.plan">
          <div class="active-plan-wrap">
            <h5 class="active-paln-title mb-2">{{user.plan.description}}</h5>
            <p class="plan-end-date mb-1" *ngIf="user.plan && user.plan.subscription_cancelled!=1 && user.plan.subscription_cancelled!=2">End date: {{user.plan.trial_ends}}</p>
          </div>

          <button type="button" class="btn btn-red ms-auto" *ngIf="user.plan && user.plan.subscription_cancelled!=1 && user.plan.subscription_cancelled!=2 && user.plan.type!='manual'" [swal]="{ title:'Confirm Please', text:'Are you sure, you want to pause subscription ?', showCancelButton: true, confirmButtonText: 'Yes' }" (confirm)="pauseSubscription(user.plan.subscription_id)">
            <div class="popover-wrap-2 ms-2">
                Pause Subscription <i *ngIf="pausing" class="fa fa-spinner fa-spin"></i>
                <div class="popover-content top">No using your account for the summer or during competition season? Click here to pause your payment and access until you’re ready to return and un-pause!</div>
            </div> 
          </button>
          <button type="button" class="btn btn-red ms-auto" [swal]="{ title:'Confirm Please', text:'Are you sure, you want to resume subscription ?', showCancelButton: true, confirmButtonText: 'Yes' }" *ngIf="user.plan && user.plan.subscription_cancelled==2 && user.plan.type!='manual'" (confirm)="resumeSubscription(user.plan.subscription_id)">Resume Subscription <i *ngIf="resuming"
              class="fa fa-spinner fa-spin"></i></button>
        </div>

        <div class="row py-4" *ngIf="plans && user.plan.type!='manual'">
          <div class="col-md-12" *ngIf="!user.plan || user.plan.subscription_cancelled!=0">
            <p class="text-red mb-2">NOTE: You can still access LEVEL 1 videos.</p>
            <p class="text-red sub-msg"></p>
          </div>
          <div class="col-md-4 mb-2" *ngFor="let plan of plans">
            <div class="plan-box" *ngIf="user && user.role!='choreographer'">
              <div class="heading mb-1">
                {{plan[0].title}}
              </div>
              <!-- <div class="sub-heading mb-3">
                        [NOVICE - MEDIAN]
                    </div> -->
              <div class="input-radios-wrap">
                <ng-container *ngFor="let subplan of plan">
                   
                    <input type="radio" [(ngModel)]="selectedplan" value="{{subplan.plan.stripe_plan_id}}" name="plan"
                      id="plan{{subplan.index}}">
                    <label class="font-mulish ft-wght-300" for="plan{{subplan.index}}">{{period(subplan.plan.period) | titlecase}} ({{subplan?.plan?.price}} USD*)</label>
                  
                </ng-container>
              </div>
            </div>
            <div class="plan-box" *ngIf="user && user.role=='choreographer'">
              <div class="heading mb-3">
                {{plan.title}}
              </div>
              <!-- <div class="sub-heading mb-3">
                      [NOVICE - MEDIAN]
                  </div> -->
              <div class="input-radios-wrap">
                <div>
                  <input type="radio" [(ngModel)]="selectedplan" value="{{plan.stripe_plan_id}}" name="plan"
                    id="plan{{plan.stripe_plan_id}}">
                  <label for="plan{{plan.stripe_plan_id}}">{{period(plan.period)}} ({{plan.price}} USD*)</label>
                </div>
              </div>
            </div>
          </div>

        </div>
        <!-- <div class="row py-4">
          <div class="col-md-4">
            <div class="plan-box">
              <div class="heading">
                LEVELS 1-3
              </div>
              <div class="sub-heading mb-3">
                [NOVICE - MEDIAN]
              </div>
              <div class="input-radios-wrap">
                <div>
                  <input type="radio" name="plan" id="plan1">
                  <label for="plan1">Monthly (54.99 USD*)</label>
                </div>
                <div>
                  <input type="radio" name="plan" id="plan2">
                  <label for="plan2">Annual (540 USD*)</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="plan-box">
              <div class="heading">
                LEVELS 1-3
              </div>
              <div class="sub-heading mb-3">
                [NOVICE - MEDIAN]
              </div>
              <div class="input-radios-wrap">
                <div>
                  <input type="radio" name="plan" id="plan1">
                  <label for="plan1">Monthly (54.99 USD*)</label>
                </div>
                <div>
                  <input type="radio" name="plan" id="plan2">
                  <label for="plan2">Annual (540 USD*)</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="plan-box">
              <div class="heading">
                LEVELS 1-3
              </div>
              <div class="sub-heading mb-3">
                [NOVICE - MEDIAN]
              </div>
              <div class="input-radios-wrap">
                <div>
                  <input type="radio" name="plan" id="plan1">
                  <label for="plan1">Monthly (54.99 USD*)</label>
                </div>
                <div>
                  <input type="radio" name="plan" id="plan2">
                  <label for="plan2">Annual (540 USD*)</label>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div>
          <!-- <p class="text-red">The Cheer Forge accepts Credit Cards only. Debit Cards, including Visa Debit, Master Debit
            etc. are not accepted.</p> -->

          <div class="d-flex justify-content-between align-items-center" *ngIf="user && (!user.plan || user.plan.type!='manual')">
            <p class="term mb-0">*Plus applicable taxes</p>
            <button type="button" class="btn btn-red mt-2 ms-auto" *ngIf="user.plan && user.plan.subscription_cancelled!=1" [swal]="{ title:'Confirm Please', text:'Are you sure you want to cancel your subscription?  You will lose access at the end of your current billing cycle.', showCancelButton: true, confirmButtonText: 'Yes' }" (confirm)="cancelSubscription(user.plan.subscription_id)">
              <div class="popover-wrap-2 ms-2">
                Cancel Subscription <i *ngIf="canceling" class="fa fa-spinner fa-spin"></i>
                <div class="popover-content top">Click here if you would like to end your subscription and don’t plan on returning for awhile.  You will lose access to our resources after your current billing cycle.</div>
              </div> 
            </button>
            <button type="button" *ngIf="user.plan && user.plan.subscription_cancelled!=2" [disabled]="selectedplan==oldsub" [swal]="{ title:'Confirm Please', text:'Click Yes to confirm your subscription change. Any new billing will be immediately added to your account.', showCancelButton: true, confirmButtonText: 'Yes' }" aria-label="Close" class="btn btn-gold mt-2 ml-auto" (confirm)="updateSubscription()">Update
              Subscription <i *ngIf="updating"
              class="fa fa-spinner fa-spin"></i></button>
            <button type="button" *ngIf="!user.plan" aria-label="Close" class="btn btn-gold mt-2 ml-auto" [swal]="{ title:'Confirm Please', text:'Click Yes to confirm your subscription change. Any new billing will be immediately added to your account.', showCancelButton: true, confirmButtonText: 'Yes' }" (confirm)="purchaseSubscription()">Update
                Subscription <i *ngIf="updating"
                class="fa fa-spinner fa-spin"></i></button>
          </div>

        </div>

        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
      </div>
      <div class="content-section" *ngIf="user && user.plantype=='own' && errorMessage!=''">
        <h4 class="mb-3">Subscription Plans</h4>
          <p class="text-red">{{errorMessage}}</p>
        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
      </div>
      <div class="content-section" *ngIf="user && user.plantype=='own' && errorMessage=='' && user.plan.subscription_cancelled==3">
        <h4 class="mb-3">Subscription Plans</h4>
        <p class="ft-wght-300" *ngIf="user && user.plan">You've successfully cancelled your current subscription. You will continue to have your subscription level access to our library until the end of your current billing cycle. Once the billing cycle is over you will only have access to our Level 1 / Novice content.
        </p>

        <div class="p-3 d-flex align-items-center active-plan-area mt-3" *ngIf="user && user.plan">
          <div class="active-plan-wrap">
            <h5 class="active-paln-title mb-2">{{user.plan.description}}</h5>
            <p class="plan-end-date mb-1" *ngIf="user.plan && user.plan.subscription_cancelled!=2">End date: {{user.plan.trial_ends}}</p>
          </div>

        </div>
      </div>
      
      <div class="content-section" *ngIf="user && user.plantype=='parent'">
        <h4 class="mb-3">Subscription Plans</h4>
        <p class="mb-3 ft-wght-300">You are using a shared Plan, you cannot update the subscription.</p>
      </div>
    </div>
  </div>
</div>